export const findObjectDifferences = (obj1, obj2) => {
  const diffKeys = [];
  for (const key in obj1) {
    if (!(key in obj2) ||
      obj1[key] !== obj2[key]) {
      diffKeys.push(key);
    }
  }
  for (const key in obj2) {
    if (!(key in obj1) ||
      obj1[key] !== obj2[key]) {
      if (!diffKeys.includes(key)) {
        diffKeys.push(key);
      }
    }
  }
  return diffKeys;
}

// Example
/*
[
  { key: "age", type: "changed", old: 30, new: 31 },
  { key: "role", type: "removed", old: "admin" },
  { key: "email", type: "added",   new: "alice@example.com" }
]
*/
export const getObjectDiff = (obj1, obj2, compareRef = false) => {
  const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
  const diffs = [];

  for (const key of allKeys) {
    const inObj1 = obj1.hasOwnProperty(key);
    const inObj2 = obj2.hasOwnProperty(key);

    if (inObj1 && inObj2) {
      const sameValue = obj1[key] === obj2[key];
      const sameRef = obj1[key] === obj2[key];
      if (!sameValue || (compareRef && !sameRef)) {
        diffs.push({ key, old: obj1[key], new: obj2[key], type: 'changed' });
      }
    } else if (inObj1 && !inObj2) {
      diffs.push({ key, old: obj1[key], new: undefined, type: 'removed' });
    } else {
      diffs.push({ key, old: undefined, new: obj2[key], type: 'added' });
    }
  }

  return diffs;
};
